<template>
  <div class="breadcrumb-wrap">
    <router-link
      tag="i"
      class="el-icon-s-home mr-10 home"
      to="/home"
    ></router-link>
    <el-breadcrumb separator="/" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <template v-for="item in breadList">
        <el-breadcrumb-item
          v-if="item.title"
          :to="{ path: item.path }"
          :key="item.path"
          >{{ item.title }}</el-breadcrumb-item
        >
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadList: []
    };
  },
  mounted() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      const matched = this.$route.matched;
      this.breadList = matched.map(item => {
        return {
          path: item.path,
          title: item.meta.title
        };
      });
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  }
};
</script>

<style lang="sass" scoped>
.breadcrumb-wrap
  display: flex
  align-items: center
.home
  cursor: pointer
</style>
